import BodySmallMedium from "./BodySmallMedium";

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            background: "#fff",
            color: "#000",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
            border: "1px solid #E0E0E0",
            fontSize: "14px",
          }}
        ><p style={{ fontWeight: "bold", marginBottom: "5px"}}>{label}</p>
          {payload.map((item, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "6px",
                padding:"5px"
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                   <div
                  style={{
                    width: "4px",  
                    height: "20px",
                    backgroundColor: item.color, 
                    marginRight: "8px",
                    borderRadius: "2px",
                  }}
                ></div>
                <span>{item.name}</span>
              </div>
              <span style={{ fontWeight: "bold", marginLeft: "10px" ,padding:"1px"}}>
                {item.value}
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };
  
  export default CustomTooltip;
  